module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAApklEQVQokYWSMQ7CMBAEV3wgosgP8gr4PxJFKgokRJMIRbQoDxh0cBbBsS8rbeG9GxdrCxiBE9AA2nDju6MdBr46A20A7n3HNFjQAQ8PLhW49Rm+26VBBK8gy5e3luAilIM5fHWvoBKY4Imfphwy77TWS9K8SGfP/hW093QX2w4rj9oOK4+eaguqwhb26RtVoCVs/9rUp1Zvko6S7oWWk2x2+OxKegMueD79pmc7zgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/addDevice/index_tips_close.png
// module id = 4wcl
// module chunks = 1